/**
 * Public support address. Single source of truth — it is rendered on the contact
 * page and offered as the escape hatch whenever the portal cannot show a client
 * their own account.
 */
export const SUPPORT_EMAIL = 'hello@evtimia.com'
